import { createContext, useContext, useState } from 'react';

const HeaderContext = createContext({ headerAutoHide: false, setHeaderAutoHide: () => {} });

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderProvider = ({ children }) => {
  const [headerAutoHide, setHeaderAutoHide] = useState(false);
  return (
    <HeaderContext.Provider value={{ headerAutoHide, setHeaderAutoHide }}>
      {children}
    </HeaderContext.Provider>
  );
};
